import formats from '../fr/formats';

export default {
  // Formats i18n.js
  ...formats,
  // Overwrite fr (standard)
  number: {
    currency: {
      format: {
        delimiter: ' ',
        format: '%u %n',
        precision: 2,
        separator: '.',
        significant: false,
        strip_insignificant_zeros: false,
        unit: 'CHF',
      },
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    format: {
      delimiter: ' ',
      precision: 2,
      separator: ',',
      significant: false,
      strip_insignificant_zeros: false,
    },
  },
  // Navigation
  navigation: {
    home: 'Accueil',
    booking: 'Réserver',
    event: 'Événements',
    event_407: 'Cours - EDG',
    enter: "S'inscrire",
    schedule: 'Planning',
    directory: 'Annuaire',
    tournament: 'Compétitions',
    membership_1: 'Adhésions',
    membership_2: 'Cotisations',
    membership_3: 'Abonnements',
    members_1: 'Les adhérents',
    members_2: 'Les membres',
    members_3: 'Les abonnés',
    my_account: 'Mon compte',
    my_profile: 'Mon profil',
    my_ids: 'Mes identifiants',
    my_events: 'Mes événements',
    my_statement: 'Mon relevé',
    my_contacts: 'Mes contacts',
    my_interests: 'Mes intérêts',
    my_bookings: 'Mes réservations',
    my_history: 'Mon historique',
    my_tournaments: 'Mes compétitions',
    my_creditcard: 'Ma carte bancaire',
    my_covid_certificate: 'Mon pass vaccinal',
  },
  event: {
    title: 'Événements - Calendrier',
    not_found: 'Aucun événement.',
  },
  event_voucher: {
    title: 'Événements - Confirmation d\'inscription',
  },
  event_pay: {
    title: 'Événements - Paiement par CB',
    not_complete1: 'Votre inscription est incomplète !',
    not_complete2: 'Veuillez choisir une option pour les événements obligatoires.',
  },
  event_past: {
    title: 'Mes événements',
    sub_title: 'Mes événements passés',
  },
  event_next: {
    sub_title: 'Mes prochains événements',
  },
  event_calendar: {
    title: 'Évévenements - Calendrier',
    choose: 'Choisissez votre événement',
    not_found: 'Aucun événement.',
  },
  event_signin: {
    title: 'Événements - S\'inscrire',
  },
  event_view: {
    show: 'Voir l\'événement',
  },
  event_enter: {
    already_in: 'Vous êtes déjà inscrit à cet événement.',
  },
  event_history: {
    list: {
      not_found: 'Aucun événement pour le moment.',
    },
    view: {
      title: 'Mon événement',
      cancellable: 'L\'annulation concerne l\'inscription à l\'événement ainsi qu\'à la compétition.',
    },
  },
};
